fox.registerWidget('Cancellation_Action', {
    configure() {
        this.registerOptions('', {
            additionalClasses: 'gdpr-small',
            hideOnOkPressed: true,
            onOkPress: (button, ...args) => {
                if (this.getOption('hideOnOkPressed')) {
                  this.hide();
                }

                return fox.Promise.resolve(button);
            },
        });

        this.callParent('configure', arguments);
    },

    show(template, text = '', ...args) {
        const content = this.rwom1('#content');
        content.setOption('template', template);
        content.setTemplateOptions('text', text);

        content.render();

        return this.callParent('show', args);
    }, 

    hide(...args) {
        fox.site.gotoPage('account');
        return this.callParent('hide', args);
    }
       
}, 'GDPR_BasePopup');


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/cancellation/widget/action-popup.es.js